<template>
  <div :class="{ 'mb-4': $vuetify.display.mobile && anySectionDisplayed, 'mt-6': !$vuetify.display.mobile && anySectionDisplayed }">
    <template v-if="!loading">
      <template v-if="eventsSectionDisplayed">
        <div class="d-flex justify-space-between align-center mt-2">
          <div class="font-size-big font-weight-bold">{{ $translate("HomeScreenSection.upcomingEvents") }}</div>
          <the-button text small :to="{ name: $routes.EVENTS }">
            {{ $translate("common.seeAll") }}
          </the-button>
        </div>
        <event-horizontal-list :events="events" />
      </template>
      <template v-if="postsSectionDisplayed">
        <div class="d-flex justify-space-between align-center mt-2">
          <div class="font-size-big font-weight-bold">{{ $translate("HomeScreenSection.recentPosts") }}</div>
          <the-button text small exact :to="{ name: $routes.GROUPS }">
            {{ $translate("HomeScreenSection.viewActivityFeed") }}
          </the-button>
        </div>
        <post-horizontal-list :posts="posts" />
      </template>
      <template v-if="myGroupsSectionDisplayed">
        <div class="d-flex justify-space-between align-center mt-2">
          <div class="font-size-big font-weight-bold my-2">{{ $translate("HomeScreenSection.myGroups") }}</div>
          <the-button text small :to="{ name: $routes.SEARCH, params: { mode: 'groups' }, query: { suggested: 'true' } }">
            {{ $translate("common.findMore") }}
          </the-button>
        </div>
        <group-horizontal-list :groups="userGroupsWithoutCourseGroups" />
      </template>
    </template>
    <loading-indicator v-else class="mt-4" />
  </div>
</template>

<script>
import { mapGetters } from "pinia"

import { useGroupsStore } from "@/store/groups.js"
import { useConfigurationStore } from "@/store/configuration.js"

import * as eventsApi from "@/api/eventsApi.js"
import * as groupApi from "@/api/groupApi.js"

import * as eventsService from "@/services/eventsService.js"

import GroupHorizontalList from "@/components/groups/GroupHorizontalList.vue"
import EventHorizontalList from "@/components/events/EventHorizontalList.vue"
import PostHorizontalList from "@/components/postables/post-lists/PostHorizontalList.vue"

export default {
  components: {
    GroupHorizontalList,
    EventHorizontalList,
    PostHorizontalList
  },
  data() {
    return {
      events: [],
      posts: [],
      loading: false,
      itemsLimit: 6
    }
  },
  computed: {
    ...mapGetters(useConfigurationStore, ["configuration"]),
    ...mapGetters(useGroupsStore, ["userGroupsWithoutCourseGroups"]),
    eventsSectionDisplayed() {
      return this.configuration.homePageSections.home_upcoming_events_enabled && this.events.length
    },
    postsSectionDisplayed() {
      return this.configuration.homePageSections.home_recent_posts_enabled && this.posts.length
    },
    myGroupsSectionDisplayed() {
      return this.$vuetify.display.mobile && this.configuration.homePageSections.home_my_groups_enabled && this.userGroupsWithoutCourseGroups.length
    },
    anySectionDisplayed() {
      return this.eventsSectionDisplayed || this.postsSectionDisplayed || this.myGroupsSectionDisplayed
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true
        await Promise.all([this.fetchEvents(), this.fetchPosts()])
      } catch (err) {
        this.$reportError(err)
      } finally {
        this.loading = false
      }
    },
    async fetchEvents() {
      if (!this.configuration.homePageSections.home_upcoming_events_enabled) {
        return
      }
      const { events } = await eventsApi.futureEvents()
      await eventsService.setRsvpData(events)
      this.events = events.slice(0, this.itemsLimit)
    },
    async fetchPosts() {
      if (!this.configuration.homePageSections.home_recent_posts_enabled) {
        return
      }
      const { posts } = await groupApi.activityFeedPosts({ cursor: null, limit: 10 })
      this.posts = posts.slice(0, this.itemsLimit)
    }
  }
}
</script>
